export default {
  "journeyDuration": "Estimated journey duration",
  "durationMinutes": "{minutes} minutes",
  "estimatedArrivalPreview": "Estimated arrival:",
  "commonDestinationPlaceholder": "Enter or select a saved destination",
  "dateGroupSummary": "{count} guests · Sorted by pickup availability",
  guestAssignedContactsHint: 'Your assigned contacts for this trip are listed below. Please contact them in advance if changes are needed.',
  navigate: 'Navigate',
  smsShort: 'SMS',
  mixedLocationsTitle: "Guests have different locations",
  mixedLocationsHint: "Selected guests have different airports or stations: {locations}. Continue only after confirming they can share a transfer, then verify the pickup location.",
  continueArrangement: "Confirm and continue",
  locationSerial: "No.",
  "locationTitle": "Transfer locations",
  "locationMenu": "Transfer settings",
  "locationSubtitle": "Manage common pickup and drop-off locations for use when creating transfer arrangements.",
  "locationAdd": "Add transfer location",
  "locationEdit": "Edit transfer location",
  "locationCount": "{count} locations",
  "locationSearch": "Search name / address / guidance / notes",
  "locationName": "Location name",
  "locationNameHint": "e.g. Terminal 2 arrivals",
  "locationAddress": "Address",
  "locationAddressHint": "Optional: address, exit or meeting point",
  "locationRegion": "Province / city / district",
  "locationRegionHint": "Select province, city and district",
  "locationGuidance": "Route guidance",
  "locationGuideLabel": "Route instructions",
  "locationGuideHint": "Describe the route, meeting instructions or precautions",
  "locationViewGuide": "View instructions",
  "locationRemarkHint": "Optional: parking or waiting instructions",
  "locationSave": "Save location",
  "locationSaved": "Location saved",
  "locationNameRequired": "Enter a location name",
  "locationDeleteHint": "Delete “{name}”? Saved arrangement text will stay unchanged.",
  "locationLoadFailed": "Failed to load locations. Please retry.",
  "noLocations": "No locations yet. Use Add transfer location above.",
  "locationImageSize": "Images must not exceed 10 MB",
  "notificationResend": "Resend",
  "notificationResendConfirm": "Resend the transfer notification to {name} ({phone})? Previous status: {status}. Estimated additional SMS credits: {units}.",
  "notificationResendUnknownWarning": "The latest query still cannot confirm delivery. The guest may already have received the SMS. Continuing may cause duplicate delivery and another charge.",
  "notificationResendStale": "The sending record has changed. Refresh and try again.",
  "notificationResendBusy": "A notification is queued or sending. Please wait.",
  "notificationResendCooldown": "Wait one minute after the previous attempt, then refresh.",
  "notificationResendSingle": "Resend to one guest at a time.",
  "notificationResendQueryRequired": "Query the latest status and acknowledge the risk of duplicate delivery before resending an unknown result.",
  "importConfirmTitle": "Confirm transfer guest selection",
  "importConfirmHint": "Review the selected guest details ({count} in total). Confirmation selects them for import; changes take effect when the task is saved.",
  "confirmGuestSelection": "Confirm selection",
  "pickupNotSet": "Not set. Set a pickup time before saving the task.",
  "noLinkedMeeting": "No linked meeting session",
  "submittedAtLabel": "Registered at",
  "importSelectionChanged": "Guest details or filter results have changed. Review and select the guests again.",
  "call": "Call",
  "callPerson": "Call {name}",
  "invalidContactPhone": "No valid contact number",
  "driverTaskTag": "Transfer · Driver / coordinator link",
  "taskStaffHeading": "Task team",
  "driverRole": "Driver",
  "driverContactRole": "Driver · Guest coordinator",
  "accompanyingRole": "Accompanying staff",
  "phoneNotProvided": "No phone number",
  "tripArrangementHeading": "Trip itinerary",
  "driverGuestsHeading": "Transfer guests",
  "driverPickedSummary": "Picked up {picked} / {total}",
  "driverPendingSummary": "Awaiting {pending} · Returned {returned}",
  "confirmPickupFor": "Confirm pickup for {name}",
  "undoPickupFor": "Undo pickup for {name}",
  "driverInteractionHint": "Tap the checkbox next to a guest, check their details and confirm pickup. The time is recorded automatically. Tap a checked box to undo a mistake. Tap Call to dial.",
  "allPeriods": "All time periods",
  "allPositions": "All positions",
  "allMeetings": "All meeting sessions",
  "resetFilters": "Reset filters",
  "period_morning": "Morning (00:00–11:59)",
  "period_afternoon": "Afternoon (12:00–17:59)",
  "period_evening": "Evening (18:00–23:59)",
  "transferDate": "Transfer date",
  "timeMissing": "Time not provided",
  "taskSearch": "Task / plate / person / phone",
  "rosterSearch": "Name / phone / organization / service",
  "filteredJourneyCount": "{count} of {total} journeys match",
  "rosterTotals": "{current} current guests · {returned} historical returns",
  "currentGuests": "Current trip guests",
  "currentGuestCount": "Current guest count",
  "returnHistoryCount": "Historical returns",
  "allPickupStates": "All pickup states",
  "filteredRosterCount": "Filtered roster: {count} of {total} entries",
  "exportFilteredRoster": "Export filtered roster",
  "printFilteredRoster": "Print filtered roster",
  "transferSheet": "Transfer arrangements sheet",
  "generatedAt": "Generated at",
  "reportScope": "Roster scope",
  "reportTaskCount": "{count} transfer tasks",
  "role": "Role",
  "pickedAtColumn": "Picked up at",
  "feedbackDetails": "Return feedback / next trip",
  "signatureLine": "Driver: ____________  Coordinator: ____________  Guest: ____________  Date: ____________",
  "printPreview": "Print preview",
  "printLayoutHint": "A4 landscape. Each task starts on a new page; long rosters repeat column headers. Select a printer or Save as PDF in the system print dialog.",
  "printFailed": "Could not open printing. Retry or check your browser print settings.",
  "noReportItems": "No transfer arrangements to export or print.",
  "eventName": "Event name",
  "manualGuestTag": "Added manually",
  "manualGuestDuplicate": "This manual guest has already been submitted. Refresh the roster.",
  "filterAll": "All",
  "importRoster": "Import guests",
  "guestName": "Guest name",
  "addGuest": "Add guest",
  "completedRosterLocked": "Guest lists cannot be changed for completed trips.",
  "rosterRemovalHint": "Removed registered guests return to their waiting queue. Manual guests do not create registrations. Picked-up guests cannot be removed.",
  "importRosterHint": "Choose waiting or returned guests travelling in the same direction in this event. They join this trip when you save.",
  "confirmImportRoster": "Import selected",
  "manualNameRequired": "Enter the guest name.",
  "rosterRequired": "Add at least one guest.",
  "feedbackMissed": "Report missed guests",
  "selectAllMissed": "Select all uncollected guests",
  "returnReasonType": "Reason for missed pickup",
  "returnNote": "Notes (required for Other)",
  "returnReason_delay": "Travel delay",
  "returnReason_personal": "Personal delay",
  "returnReason_absent": "Not at the meeting point",
  "returnReason_other": "Other",
  "feedbackReporter": "Reported by",
  "undoPicked": "Undo pickup",
  "undoPickedSuccess": "Pickup mark removed",
  "undoPickedConfirm": "Remove the pickup mark for {name}?",
  "pickupTimestampHint": "Check the guest and trip locations. Confirmation records the pickup time. You can undo an incorrect mark.",
  "returnFeedbackRequired": "Select guests and a reason, and provide any required notes.",
  "apiRosterRetain": "Keep at least one guest in the trip.",
  "apiRosterCompleted": "Guest lists cannot be changed for completed trips.",
  "apiRosterRemove": "You can only remove guests from this trip. Refresh the roster.",
  "apiRosterProtected": "Guests already picked up or with a return record in this trip cannot be removed.",
  "apiReasonRequired": "Select a reason for the missed pickup.",
  "apiOtherNote": "Provide notes when selecting Other.",
  "apiReadyBefore": "The earliest pickup cannot be before this trip’s pickup time.",
  "apiChooseSubmission": "Use only one guest selection method.",
  "apiPickupSingle": "Confirm pickup status for one guest at a time.",
  "incompleteReturn": "The return record is incomplete. Check the original trip before reassigning.",
  "invalidReturnTask": "A returned guest must be assigned to a valid new trip.",
  "changedJourney": "The selected journey has changed. Refresh the roster.",
  "capacityHint": "Capacity is read from the vehicle type (for example, “Business van · 7 seats”). Add the seat count to enable capacity checks.",
  "scheduleHint": "Set pickup and drop-off times first. Vehicles, drivers and accompanying staff cannot be booked for overlapping trips.",
  "scheduleConflict": "Vehicle or staff time conflict. Change resources or adjust the times.",
  "duplicateStaff": "The driver and accompanying staff must be different people. Check their phone numbers.",
  "capacityExceeded": "Guest count exceeds vehicle capacity. Split the trip or choose another vehicle.",
  "duplicateGuest": "The same guest cannot be added to this trip more than once.",
  "returnTooEarly": "Reassigned pickup must be at or after the original drop-off and the guest’s earliest pickup time.",
  "returnLocationMismatch": "Pickup locations do not match. Arrange separate trips for different locations.",
  "returnTaskPrefix": "Reassigned transfer · ",
  "endTimeMissing": "End time missing",
  "availability": "Availability",
  "available": "Available",
  "missingDriver": "Driver details missing",
  "returnReadyAt": "Earliest pickup time",
  "returnPickupLocation": "Pickup location for reassignment",
  "returnDetailsHint": "The guest will return to the waiting queue. Set their earliest pickup time and location for the next trip.",
  "nextArrangement": "Next arrangement",
  "noNextArrangement": "Awaiting reassignment",
  "noJoinableTask": "No trip matches direction, pickup time, location and capacity. Create a new arrangement.",
  "alreadyPickedReturn": "A guest already picked up cannot be marked as missed.",
  "guestContact": "Guest coordinator",
  "guestContactPhone": "Coordinator phone",
  "selectedGuestCount": "{count} guests selected",
  "chooseGuestContact": "Choose accompanying staff",
  "batchGuestContact": "Assign accompanying staff in bulk",
  "batchAssignContacts": "Assign selected",
  "guestAssignmentHint": "Select guests to assign in bulk, or choose individually below. Unassigned guests default to the first accompanying staff member.",
  "defaultGuestContact": "Unassigned (default: {name})",
  "driverContactName": "Driver {name} (automatic)",
  "driverContactPending": "The selected vehicle's driver will coordinate",
  "assignContactFor": "Assign a coordinator for {name}",
  "automaticContact": "Automatic assignment",
  "guestAssignmentUnavailable": "Guest coordinator assignments are unavailable. Contact an administrator to complete setup.",
  "guestAssignmentScope": "Assign only selected guests in this task. Refresh the roster.",
  "guestAssignmentStaffScope": "Select a coordinator from this task's accompanying staff.",
  "guestAssignmentDuplicateStaff": "Do not add the same accompanying staff member twice to this task.",
  "staffVerificationTitle": "Transfer staff verification",
  "staffVerificationHeading": "Verify to view your transfer task",
  "staffVerificationIntro": "For this task's assigned driver and accompanying staff only.",
  "staffVerificationHint": "Enter your registered name and mobile number to access the guest roster.",
  "verifyNameHint": "Enter your registered name",
  "verifyPhoneHint": "Enter your registered mobile number",
  "verifyAndEnter": "Verify and enter",
  "staffVerificationHelp": "If verification fails, ask event staff to check the contacts assigned to this task.",
  "staffVerificationPassed": "Identity verified",
  "changeIdentity": "Switch identity",
  "staffVerificationRequired": "Enter your name and mobile number.",
  "staffVerificationMismatch": "The name or mobile number does not match this task's assigned contacts. Check and try again.",
  "staffVerificationExpired": "Verification expired. Enter your name and mobile number again.",
  "staffVerificationTooMany": "Too many verification attempts. Try again in one minute.",
  "staffTaskUnavailable": "This transfer task is unavailable. Check your connection or ask staff to confirm the link.",
  "guestTravelTitle": "My transfer arrangements",
  "guestGreeting": "Hello, {name}",
  "editTravelTime": "Edit travel time",
  "guestPrivateHint": "This page shows only your transfer. Contact your coordinator in advance to change the pickup plan.",
  "guestServiceInactive": "Your transfer request or registration status changed. Contact event staff to verify it.",
  "guestChangePending": "Your travel details changed. Staff must verify the existing pickup plan; follow their confirmation.",
  "guestWaiting": "Transfer awaiting confirmation",
  "guestReturnWaiting": "Not picked up; awaiting reassignment",
  "guestWaitingHint": "Staff are reviewing your transfer. Refresh this page later for the latest arrangements.",
  "guestNeedsVerification": "Needs verification",
  "yourContacts": "Your transfer contacts",
  "driverShort": "Driver",
  "staffShort": "Staff",
  "driverAndContact": "Driver and guest coordinator",
  "yourStaff": "Your accompanying staff",
  "callContact": "Call",
  "vehicleInformation": "Vehicle information",
  "checkPlate": "Check this plate before boarding",
  "journeyPlan": "Journey plan",
  "yourReturnHistory": "Your transfer history",
  "guestRearranged": "Reassigned; see the latest details above",
  "guestContactHint": "Contact your accompanying staff to adjust the pickup. If none are assigned, contact the driver.",
  "refreshMyTrip": "Refresh my arrangements",
  "guestLinkInvalid": "Transfer details are unavailable",
  "guestLinkHelp": "Check your connection and refresh. If the link is no longer valid, ask event staff for a new personal link.",
  "guestTimeEditHint": "This updates the travel time in your registration. The vehicle and planned pickup time stay unchanged until staff review them.",
  "guestTimeSaved": "Travel time updated. Staff will verify the transfer plan.",
  "guestTimeFailed": "Unable to save travel time. Try again later.",
  "guestTimeLocked": "This journey cannot be edited. Contact event staff.",
  "guestTimeConflict": "Journey details changed. Refresh before editing again.",
  "guestLinksUnavailable": "Guest links are temporarily unavailable. Contact an administrator to complete setup and try again.",
  "driverTaskLink": "Driver / transfer staff link",
  "driverTaskLinkHint": "View the full roster and confirm pickups or missed pickups. Share only with the assigned driver and staff.",
  "guestPersonalLinks": "Personal guest travel links",
  "guestLinkSearch": "Search name / phone / organization",
  "guestLinkPrivacyHint": "Each guest has a personal link. Send it individually; guests can view only their own transfer details.",
  "guestLinkFor": "Personal transfer link for {name}",
  "qrCode": "QR code",
  "preview": "Preview",
  "resourceSetupHelp": "Adding vehicles, staff and invitation links is temporarily unavailable. Refresh after setup is complete.",
  "resourceRetryHelp": "Check your connection and refresh. If the problem continues, contact an administrator.",
  "resourceUnavailableEmpty": "Records are temporarily unavailable. Refresh and try again.",
  "emptyVehicles": "No vehicles yet. Use Add vehicle above, or invite a driver to register.",
  "emptyStaff": "No accompanying staff yet. Add someone above, or share a registration invitation.",
  "scanToRegister": "Scan to register",
  "inviteHelp": "Share this link or QR code with the registrant. Refresh the list after they submit to see their details.",
  "continueRegistration": "Register another",
  "pickupTimeLabel": "Pickup time",
  "pickupLocationLabel": "Pickup location",
  "dropoffLocationLabel": "Drop-off location",
  "taskInformation": "Task information",
  "routeSectionHint": "Pickup and drop-off times and locations",
  "taskNameExample": "E.g. Capital Airport T3 → Tianhe Sports Center",
  "pickupArrangement": "Pickup details",
  "dropoffArrangement": "Drop-off details",
  "chooseDateTime": "Select date and time",
  "pickupPlaceExample": "Prefilled from guest locations; you can edit it",
  "autoPickupTitle": "Automatically filled; editable",
  "autoPickupHint": "Prefilled from the selected guests' arrival location. Adjust the exit or meeting point as needed.",
  "autoPickupMultiple": "The guests have different locations. Choose a suggestion or enter this journey's meeting point.",
  "autoPickupEmpty": "The selected guests have no location on record. Enter the pickup location, exit and meeting point.",
  "destinationExample": "E.g. Tianhe Sports Center, East Gate",
  "noteDescription": "Additional instructions",
  "noteExample": "E.g. Contact staff at the sign outside the exit",
  "vehicleAndStaff": "Vehicle and accompanying staff",
  "vehicleAutofillHint": "Selecting a vehicle fills in the driver details",
  "transferVehicle": "Transfer vehicle",
  "noVehicleChosen": "No vehicle selected. Choose one or enter the details manually.",
  "manualVehicle": "Enter vehicle and driver details manually",
  "optionalMultiple": "Optional; select multiple",
  "driverFallbackHint": "If no accompanying staff are assigned, the driver will coordinate with guests.",
  "removeStaffPerson": "Remove staff member {name}",
  "transferGuestList": "Transfer guest list",
  "guestListCount": "{count} guests · Visible to the driver and accompanying staff",
  "travelMode": "Travel mode",
  "flightTrain": "Flight / Train",
  "noData": "No data",
  "saveArrangement": "Save transfer arrangement",
  "vehicleSearch": "Search plate, vehicle type, driver or phone",
  "selectResource": "Select",
  "routeVehicleRequired": "Enter pickup location, drop-off time, destination and vehicle details.",
  "arrivalAfterPickup": "Drop-off time must be later than pickup time.",
  "sourceIncomplete": "The travel mode, time or service number is unconfirmed. Verify and complete the registration.",
  "serviceDirection": "Journey direction",
  "sourceDirectionChanged": "The arrival/departure direction changed. Reassign this journey first.",
  "invalidInput": "Check the information you entered.",
  "sessionExpired": "Your session expired. Please sign in again.",
  "forbidden": "You do not have permission to perform this action.",
  "notFound": "The requested resource was not found.",
  "tooManyRequests": "Too many requests. Try again later.",
  "serviceUnavailable": "The service is temporarily unavailable. Try again later.",
  "serverError": "A server error occurred. Contact the administrator.",
  "networkError": "A network error occurred. Try again later.",
  "chooseFile": "Choose file",
  "noFileSelected": "No file selected",
  "pageTitle": "Transfer settings",
  "tabLabel": "Transfer sections",
  "arrangements": "Transfer arrangements",
  "vehicles": "Vehicles",
  "receivers": "Accompanying staff",
  "overview": "Transfer overview",
  "overviewScope": "Event totals · Unaffected by list filters",
  "people": "people",
  "trips": "trips",
  "journeys": "journeys",
  "arrangementUnit": "arrangements",
  "personUnit": "people",
  "requiredGuests": "Guests needing transfers",
  "pendingGuests": "Guests awaiting assignment",
  "planned": "Planned transfers",
  "picked": "Picked up",
  "awaitingPickup": "Awaiting pickup",
  "pickupProgress": "Pickup progress",
  "assignedSummary": "{people} people assigned · {rate}% assigned",
  "returnedSummary": "Including {count} returned journeys",
  "plannedNote": "Returned journeys count again after reassignment",
  "pickedNote": "Based on confirmed guest pickups",
  "awaitingNote": "Assigned, pickup not yet confirmed",
  "progressNote": "Picked up / Planned transfers",
  "tipResponsibility": "The driver is responsible for this trip. Accompanying staff are optional; the driver contacts guests when none are assigned",
  "tipDetails": "{responsibility}: record pickup and expected drop-off times and locations, the vehicle plate number, and the guest list for this trip.",
  "tipActions": "Select in-progress tasks, then use {export} / {print} above to prepare transfer sheets with the driver, accompanying staff, and all guests. Use {taskLink} on a task to generate links and QR codes for the driver and guest H5 pages.",
  "arrangementStatus": "Assignment status",
  "pending": "Awaiting assignment",
  "returnedPending": "Returned for reassignment",
  "returnedPinned": "{count} journeys · Pinned · Sorted by earliest pickup time",
  "selectReturned": "Select returned guests",
  "ongoing": "In progress",
  "completed": "Completed",
  "pendingPeople": "People awaiting assignment",
  "returnedPeople": "People awaiting reassignment",
  "listTotal": "{count} journeys",
  "returnedSource": "Journeys marked Not picked up by the driver or staff",
  "approvedSource": "Approved registrations requesting a transfer",
  "refresh": "Refresh",
  "create": "Create arrangement",
  "allTransport": "All transport modes",
  "allNumbers": "All service numbers",
  "allDates": "All dates",
  "allOrganizations": "All organizations",
  "allServices": "All services",
  "arrivalService": "Arrival · Pickup",
  "departureService": "Departure · Drop-off",
  "namePhone": "Name / Phone",
  "selection": "{selected} selected / {total} journeys",
  "selectFiltered": "Select all filtered",
  "clearSelection": "Clear selection",
  "nextTrip": "Arrange next trip",
  "join": "Add to existing task",
  "pagination": "Page {page} / {pages} · 20 per page",
  "selectPage": "Select this page",
  "selectJourney": "Select {name} – {direction} journey",
  "arrival": "Arrival",
  "departure": "Departure",
  "arrivalTag": "Arrival · Pickup",
  "departureTag": "Departure · Drop-off",
  "name": "Name",
  "notPicked": "Not picked up on this trip",
  "serviceNumber": "Service number",
  "scheduledTime": "Expected arrival / departure",
  "notProvided": "Not provided",
  "phone": "Phone",
  "organization": "Organization",
  "position": "Position / Role",
  "meetings": "Meeting schedule",
  "availablePickup": "Expected pickup time",
  "timeNote": "Journeys are synchronized when registrations succeed or are approved. Refresh reads saved transfer records; unassigned journeys follow registration updates.",
  "editArrangement": "Edit transfer arrangement",
  "joinArrangement": "Add to an existing transfer task",
  "createArrangement": "Create transfer arrangement",
  "selectedJourneys": "{count} {direction} journeys selected",
  "transferTask": "Transfer task",
  "chooseTask": "Select an in-progress task in the same direction",
  "arrangementName": "Arrangement name",
  "pickupTime": "Pickup time",
  "plannedArrival": "Expected drop-off time",
  "chooseVehicle": "Select vehicle",
  "chooseVehicleHint": "Select from Vehicles",
  "driverName": "Driver name",
  "driverPhone": "Driver phone",
  "vehiclePlate": "Vehicle / Plate",
  "carType": "Vehicle type / Seats",
  "carTypeExample": "e.g. Coach · 45 seats",
  "chooseReceivers": "Select accompanying staff",
  "chooseReceiversHint": "Select accompanying staff (optional)",
  "staff": "Accompanying staff",
  "contactPhone": "Contact phone",
  "delete": "Delete",
  "addStaff": "Add accompanying staff",
  "pickupPlace": "Pickup location",
  "destination": "Destination",
  "note": "Notes",
  "taskStatus": "Task status",
  "cancel": "Cancel",
  "confirmArrangement": "Confirm arrangement",
  "batchLimit": "Select no more than 100 journeys per operation. Narrow your filters.",
  "separateDirections": "Arrange arrival and departure journeys separately.",
  "arrivalName": "Arrival transfer",
  "departureName": "Departure transfer",
  "chooseTaskRequired": "Select a transfer task.",
  "nameTimeRequired": "Enter an arrangement name and pickup time.",
  "arrangementSaved": "Transfer arrangement saved.",
  "selectTasks": "Select all tasks",
  "selectedTasks": "{count} selected",
  "export": "Export",
  "print": "Print",
  "filteredTasks": "Showing {count} / {total} transfer arrangements",
  "departs": "departure · Plate",
  "viewRoster": "Guest list",
  "taskLink": "Task link",
  "edit": "Edit",
  "associatedMeetings": "Linked meetings",
  "pickupDetails": "Pickup time / Location",
  "dropoffDetails": "Expected drop-off / Location",
  "plateColumn": "Vehicle plate",
  "transferPeople": "Transfer team",
  "driver": "Driver",
  "accompanying": "Staff",
  "returned": "Returned",
  "guestListLabel": "Guests",
  "personShort": "people",
  "moreGuests": "{count} guests in total",
  "noCompleted": "No completed arrangements",
  "noOngoing": "No in-progress arrangements",
  "guestRoster": "Transfer guest list",
  "number": "Service number",
  "formTime": "Expected time from form",
  "pickupStatus": "Pickup status",
  "taskLinkTitle": "Driver / Staff task link",
  "taskLinkHint": "Share this link with the driver or accompanying staff to confirm pickups or report missed pickups on their mobile page.",
  "copyLink": "Copy link",
  "openH5": "Open mobile page",
  "task": "Task",
  "pickupAt": "Pickup time",
  "pickupLocation": "Pickup location",
  "dropoffAt": "Drop-off time",
  "dropoffLocation": "Drop-off location",
  "plate": "Plate",
  "carTypeCompact": "Vehicle type / Seats",
  "guest": "Guest",
  "transport": "Transport",
  "printBlocked": "Allow pop-ups to open the print window.",
  "deleteArrangementHint": "Deleting this arrangement returns unserved guests to the assignment queue. Tasks with pickup or return records cannot be deleted.",
  "deleteArrangement": "Delete transfer arrangement",
  "deleted": "Deleted.",
  "linkCopied": "Link copied.",
  "manualCopy": "Copy the link manually from the text field.",
  "vehicle": "Vehicle",
  "resourceCountVehicles": "{count} vehicles",
  "resourceCountStaff": "{count} accompanying staff",
  "inviteLink": "Invitation link",
  "addResource": "Add {title}",
  "editResource": "Edit {title}",
  "noResources": "No records. Use Add above to create one.",
  "sequence": "No.",
  "vehiclePhoto": "Vehicle photo",
  "noPhoto": "No photo",
  "plateNumber": "License plate",
  "responsibleArea": "Assigned area",
  "linkedTasks": "Linked transfer tasks",
  "countTasks": "{count} tasks",
  "actions": "Actions",
  "remove": "Remove",
  "save": "Save",
  "inviteTitle": "{title} registration invitation",
  "vehicleInviteHint": "Invite drivers to register their vehicle photo, plate, vehicle type and contact details.",
  "staffInviteHint": "Invite accompanying staff to register their name, contact details and assigned area.",
  "inviteH5Title": "{title} mobile registration",
  "expiresAt": "Valid until {time}",
  "close": "Close",
  "taskName": "Task name",
  "status": "Status",
  "resourcesFailed": "Unable to load resources. Try again.",
  "vehicleRequired": "Complete the required fields and upload a vehicle photo.",
  "staffRequired": "Enter a name and phone number.",
  "invalidPhone": "Enter a valid mobile number.",
  "saved": "Saved.",
  "removeVehicleHint": "Delete this vehicle? Update any linked task arrangements first.",
  "removeStaffHint": "Remove this staff member? Update any linked task arrangements first.",
  "removeResource": "Remove transfer resource",
  "removed": "Removed.",
  "copied": "Copied.",
  "awaitingPhoto": "Upload a photo",
  "photoHint": "JPG, PNG or WebP, up to 10 MB per photo",
  "plateExample": "e.g. AB12345",
  "driverNameHint": "Enter driver name",
  "driverContact": "Driver contact number",
  "phoneHint": "Enter mobile number",
  "nameHint": "Enter name",
  "areaHint": "e.g. Airport arrivals hall",
  "noteHint": "Additional notes (optional)",
  "invalidPhoto": "Choose a JPG, PNG or WebP image no larger than 10 MB.",
  "registrationTitle": "{title} registration",
  "registrationHint": "Complete the form below. Event staff will arrange transfers after submission.",
  "registered": "Registration submitted",
  "awaitStaff": "Please wait for event staff to arrange your transfer.",
  "submitRegistration": "Submit registration",
  "invalidInvite": "This registration link is invalid or expired. Contact event staff.",
  "registerFailed": "Registration failed. Try again.",
  "noPlate": "No plate provided",
  "pickupLabel": "Pickup:",
  "dropoffLabel": "Drop-off:",
  "driverLabel": "Driver:",
  "staffLabel": "Staff:",
  "h5Roster": "Guest list ({count})",
  "h5Counts": "Picked up {picked} · Awaiting {pending} · Returned {returned}",
  "pickedAtTime": "Picked up {time}",
  "confirmPicked": "Confirm pickup",
  "missed": "Not picked up",
  "noGuests": "No guests",
  "refreshTask": "Refresh task",
  "taskFailed": "Unable to load the task. Try again later.",
  "missedConfirm": "Was {name} not picked up on this trip? Submitting will return this journey for reassignment.",
  "reasonHint": "Reason (optional)",
  "reasonLimit": "The reason must be at most 255 characters.",
  "pickedConfirm": "Confirm that {name} has been picked up?",
  "pickupConfirmTitle": "Confirm pickup",
  "returnedSuccess": "Returned for reassignment.",
  "pickedSuccess": "Pickup confirmed.",
  "confirm": "Confirm",
  "notInitialized": "Vehicle and staff management is temporarily unavailable. Contact an administrator to complete setup and try again.",
  "duplicateResource": "This vehicle or staff member is already registered.",
  "linkedResourceError": "This resource is linked to transfer tasks. Update those arrangements first.",
  "validPlate": "Enter a valid license plate.",
  "photoSaveFailed": "Unable to save the photo. Try again.",
  "inviteExpired": "The registration link is invalid or expired.",
  "waitingOnly": "Only unassigned or returned journeys can be assigned. Refresh the list.",
  "directionsError": "Create separate arrangements for arrivals and departures.",
  "taskChanged": "This task is completed or its journey direction does not match.",
  "ongoingOnly": "Only in-progress journeys can be changed.",
  "deleteRecorded": "Tasks with pickup or return records cannot be deleted.",
  "invalidVehicle": "The selected vehicle is unavailable or belongs to another event.",
  "invalidStaff": "The selected staff member is unavailable or belongs to another event.",
  "journeyChanged": "A selected journey changed, was cancelled, or belongs to another event. Refresh the list.",
  "completedLocked": "This task is completed. Pickup status can no longer be changed.",
  "guestChanged": "The guest was returned, reassigned, or is not part of this task. Refresh the page.",
  "requestFailed": "The operation failed. Try again later.",
  "returnedPrefix": "Returned ·",
  "sourceChanged": "Registration changed",
  "sourceChangedCount": "{count} registrations changed. Review the guest list before adjusting arrangements.",
  "sourceChangeColumn": "Registration changes",
  "sourceUpdated": "Registration details updated",
  "sourceCancelled": "Transfer cancelled or field disabled",
  "sourceUnapproved": "Registration is no longer approved",
  "sourceDeleted": "Registration deleted",
  "sourceMoved": "Registration moved to another event",
  "sourceKept": "The arrangement and original journey are retained. This does not automatically return the guest for reassignment.",
  "sourceInactiveHint": "This journey is no longer eligible for pickup. Its history is retained and it no longer counts as awaiting pickup.",
  "sourceField": "Field",
  "sourceBefore": "When assigned",
  "sourceAfter": "Latest registration",
  "applySource": "Apply registration changes",
  "applySourceConfirm": "Apply the latest registration details? The vehicle and pickup/drop-off schedule remain unchanged. Check whether those arrangements also need updating.",
  "sourceApplied": "Registration details updated; arrangement retained.",
  "snapshotNotInitialized": "Transfer task synchronization is not initialized. Apply the snapshot migration and synchronize historical registrations first.",
  "sourceAcknowledgeError": "Only active, uncollected, in-progress journeys can accept registration changes. Refresh the list.",
  "sourcePickupBlocked": "The registration has changed. Contact event staff to confirm it before proceeding.",
  "notifyGuests": "Notify guests",
  "notificationIntro": "Send the Guest Reception SMS with a private transfer link to the selected guests.",
  "notificationTemplate": "SMS template",
  "notificationRecipients": "Recipients",
  "notificationHistory": "Send history",
  "notificationSelectEligible": "Select eligible guests",
  "notificationSelection": "{count} of {total} selected; estimated {units} SMS credits (up to 100 guests per batch)",
  "notificationLastStatus": "Notification status",
  "notificationCreatedAt": "Submitted at",
  "notificationDeliveredAt": "Delivered at",
  "notificationQuery": "Check delivery",
  "notificationSend": "Send transfer notifications",
  "notificationPreview": "SMS preview",
  "notificationConfirm": "Send transfer notifications to {count} guests? Estimated cost: {units} SMS credits; see the records for actual usage.",
  "notificationQueued": "Notifications submitted to the queue. Check the send history for results.",
  "notificationRetryHint": "Submission is unconfirmed. Check the history first. Resubmitting the same selection reuses this request.",
  "notificationDeliveryHint": "Provider acceptance does not confirm delivery. Failed or skipped recipients can be selected again after refreshing. Check delivery before retrying an unknown result.",
  "notificationStorageUnavailable": "Notifications are not initialized. Contact an administrator.",
  "notificationSmsDisabled": "SMS sending is disabled. You can preview messages and view the send history.",
  "notificationTemplatePending": "The transfer SMS template is a placeholder. Sending will be available after the approved template is configured.",
  "notificationGatewayPending": "SMS gateway configuration is pending. Contact an administrator.",
  "notificationPublicUrlPending": "Configure a publicly accessible guest H5 URL before sending.",
  "notificationJourneyChanged": "The journey changed, was cancelled, collected or completed. Refresh and review the roster.",
  "notificationUnsupportedPhoneRegion": "SMS is available only for mainland China mobile numbers (+86)",
  "phone_region_unsupported": "SMS to overseas numbers is unavailable; only mainland China mobile numbers (+86) are supported",
  "notificationInvalidPhone": "Phone number missing or invalid",
  "notificationAlreadySubmitted": "This arrangement has already been notified or is being sent. Review its send history first.",
  "notificationRequestChanged": "This request has a different recipient list. Refresh and try again.",
  "notificationQuotaInsufficient": "Insufficient company SMS credits. This batch was not sent. Recharge, refresh and submit again.",
  "notificationLoadFailed": "Unable to load recipients. Refresh and try again.",
  "notificationLimit": "Select up to 100 guests per batch.",
  "notificationStatus_none": "Not notified",
  "notificationStatus_pending": "Pending",
  "notificationStatus_queued": "Queued",
  "notificationStatus_sending": "Sending",
  "notificationStatus_sent": "Accepted by provider",
  "notificationStatus_delivered": "Delivered",
  "notificationStatus_submit_failed": "Submission failed",
  "notificationStatus_failed": "Delivery failed",
  "notificationStatus_unknown": "Unknown outcome",
  "notificationStatus_skipped": "Skipped",
  "notificationTemplateName": "Guest Reception",
  "incompletePlan": "Complete the pickup location, drop-off time and location, vehicle and driver details.",
  "invalidDriverContact": "Enter a valid driver phone number and ensure the driver name is provided.",
  "unresolvedGuests": "Some guests have not been handled. Confirm pickup or mark them as not picked up on the driver/staff H5 before completing the task.",
  "invalidReceiverContact": "Provide a name and valid phone number for every accompanying staff member."
}
